import { Region } from '../typings/common';

export const OPEN_REGIONS_EDITOR = 'OPEN_REGIONS_EDITOR';
export type OPEN_REGIONS_EDITOR = typeof OPEN_REGIONS_EDITOR;

export interface OpenRegionsEditor {
    type: OPEN_REGIONS_EDITOR;
    id: string;
    selectedMap: Record<number, boolean>;
    tree: Region[];
}

export function openRegionsEditor(
    id: string,
    selectedMap: Record<number, boolean>,
    tree: Region[]
): OpenRegionsEditor {
    return {
        type: OPEN_REGIONS_EDITOR,
        id,
        selectedMap,
        tree
    };
}

export const SELECT_REGIONS_EDITOR_ITEM = 'SELECT_REGIONS_EDITOR_ITEM';
export type SELECT_REGIONS_EDITOR_ITEM = typeof SELECT_REGIONS_EDITOR_ITEM;

export interface SelectRegionsEditorItem {
    type: SELECT_REGIONS_EDITOR_ITEM;
    id: string;
    node: Region;
}

export function selectRegionsEditorItem(
    id: string,
    node: Region
): SelectRegionsEditorItem {
    return {
        type: SELECT_REGIONS_EDITOR_ITEM,
        id,
        node
    };
}

export const DESELECT_REGIONS_EDITOR_ITEM = 'DESELECT_REGIONS_EDITOR_ITEM';
export type DESELECT_REGIONS_EDITOR_ITEM = typeof DESELECT_REGIONS_EDITOR_ITEM;

export interface DeselectRegionsEditorItem {
    id: string;
    type: DESELECT_REGIONS_EDITOR_ITEM;
    node: Region;
}

export function deselectRegionsEditorItem(
    id: string,
    node: Region
): DeselectRegionsEditorItem {
    return {
        type: DESELECT_REGIONS_EDITOR_ITEM,
        id,
        node
    };
}

export const EXPAND_REGIONS_EDITOR_ITEM = 'EXPAND_REGIONS_EDITOR_ITEM';
export type EXPAND_REGIONS_EDITOR_ITEM = typeof EXPAND_REGIONS_EDITOR_ITEM;

export interface ExpandRegionsEditorItem {
    type: EXPAND_REGIONS_EDITOR_ITEM;
    id: string;
    node: Region;
}

export function expandRegionsEditorItem(
    id: string,
    node: Region
): ExpandRegionsEditorItem {
    return {
        type: EXPAND_REGIONS_EDITOR_ITEM,
        id,
        node
    };
}

export const COLLAPSE_REGIONS_EDITOR_ITEM = 'COLLAPSE_REGIONS_EDITOR_ITEM';
export type COLLAPSE_REGIONS_EDITOR_ITEM = typeof COLLAPSE_REGIONS_EDITOR_ITEM;

export interface CollapseRegionsEditorItem {
    id: string;
    type: COLLAPSE_REGIONS_EDITOR_ITEM;
    node: Region;
}

export function collapseRegionsEditorItem(
    id: string,
    node: Region
): CollapseRegionsEditorItem {
    return {
        type: COLLAPSE_REGIONS_EDITOR_ITEM,
        id,
        node
    };
}

export const SELECT_QUICK_REGIONS_EDITOR_ITEM =
    'SELECT_QUICK_REGIONS_EDITOR_ITEM';
export type SELECT_QUICK_REGIONS_EDITOR_ITEM = typeof SELECT_QUICK_REGIONS_EDITOR_ITEM;

export interface SelectQuickRegionsEditorItem {
    type: SELECT_QUICK_REGIONS_EDITOR_ITEM;
    id: string;
    nodeIds: string[];
    tree: Region[];
}

export function selectQuickRegionsEditorItem(
    id: string,
    nodeIds: string[],
    tree: Region[]
): SelectQuickRegionsEditorItem {
    return {
        type: SELECT_QUICK_REGIONS_EDITOR_ITEM,
        id,
        nodeIds,
        tree
    };
}

export const DESELECT_QUICK_REGIONS_EDITOR_ITEM =
    'DESELECT_QUICK_REGIONS_EDITOR_ITEM';
export type DESELECT_QUICK_REGIONS_EDITOR_ITEM = typeof DESELECT_QUICK_REGIONS_EDITOR_ITEM;

export interface DeselectQuickRegionsEditorItem {
    type: DESELECT_QUICK_REGIONS_EDITOR_ITEM;
    id: string;
    nodeIds: string[];
    tree: Region[];
}

export function deselectQuickRegionsEditorItem(
    id: string,
    nodeIds: string[],
    tree: Region[]
): DeselectQuickRegionsEditorItem {
    return {
        type: DESELECT_QUICK_REGIONS_EDITOR_ITEM,
        id,
        nodeIds,
        tree
    };
}

export const START_CHANGE_FILTER_TEXT_REGIONS_EDITOR =
    'START_CHANGE_FILTER_TEXT_REGIONS_EDITOR';
export type START_CHANGE_FILTER_TEXT_REGIONS_EDITOR = typeof START_CHANGE_FILTER_TEXT_REGIONS_EDITOR;

export interface StartChangeFilterTextRegionsEditor {
    type: START_CHANGE_FILTER_TEXT_REGIONS_EDITOR;
    id: string;
    value: string;
    tree: Region[];
}

export function startChangeFilterTextRegionsEditor(
    id: string,
    value: string,
    tree: Region[]
): StartChangeFilterTextRegionsEditor {
    return {
        type: START_CHANGE_FILTER_TEXT_REGIONS_EDITOR,
        id,
        value,
        tree
    };
}

export const CHANGE_FILTER_TEXT_REGIONS_EDITOR =
    'CHANGE_FILTER_TEXT_REGIONS_EDITOR';
export type CHANGE_FILTER_TEXT_REGIONS_EDITOR = typeof CHANGE_FILTER_TEXT_REGIONS_EDITOR;

export interface ChangeFilterTextRegionsEditor {
    type: CHANGE_FILTER_TEXT_REGIONS_EDITOR;
    id: string;
    value: string;
    tree: Region[];
}

export function changeFilterTextRegionsEditor(
    id: string,
    value: string,
    tree: Region[]
): ChangeFilterTextRegionsEditor {
    return {
        type: CHANGE_FILTER_TEXT_REGIONS_EDITOR,
        id,
        value,
        tree
    };
}

export const SAVE_CHANGES_REGIONS_EDITOR = 'SAVE_CHANGES_REGIONS_EDITOR';
export type SAVE_CHANGES_REGIONS_EDITOR = typeof SAVE_CHANGES_REGIONS_EDITOR;

export interface SaveChangesRegionsEditor {
    type: SAVE_CHANGES_REGIONS_EDITOR;
    id: string;
    tree: Region[];
}

export function saveChangesRegionsEditor(
    id: string,
    tree: Region[]
): SaveChangesRegionsEditor {
    return {
        type: SAVE_CHANGES_REGIONS_EDITOR,
        id,
        tree
    };
}

export const CANCEL_CHANGES_REGIONS_EDITOR = 'CANCEL_CHANGES_REGIONS_EDITOR';
export type CANCEL_CHANGES_REGIONS_EDITOR = typeof CANCEL_CHANGES_REGIONS_EDITOR;

export interface CancelChangesRegionsEditor {
    type: CANCEL_CHANGES_REGIONS_EDITOR;
    id: string;
    selectedMap: Record<number, boolean>;
}

export function cancelChangesRegionsEditor(
    id: string,
    selectedMap: Record<number, boolean>
): CancelChangesRegionsEditor {
    return {
        type: CANCEL_CHANGES_REGIONS_EDITOR,
        id,
        selectedMap
    };
}

export const CLEAR_SELECTED_ITEMS_REGIONS_EDITOR =
    'CLEAR_SELECTED_ITEMS_REGIONS_EDITOR';
export type CLEAR_SELECTED_ITEMS_REGIONS_EDITOR = typeof CLEAR_SELECTED_ITEMS_REGIONS_EDITOR;

export interface ClearSelectedRegionsEditorItems {
    type: CLEAR_SELECTED_ITEMS_REGIONS_EDITOR;
    id: string;
}

export function clearSelectedRegionsEditorItems(
    id: string
): ClearSelectedRegionsEditorItems {
    return {
        type: CLEAR_SELECTED_ITEMS_REGIONS_EDITOR,
        id
    };
}

export const RESET_REGIONS_EDITOR = 'RESET_REGIONS_EDITOR';
export type RESET_REGIONS_EDITOR = typeof RESET_REGIONS_EDITOR;

export interface ResetRegionsEditor {
    type: RESET_REGIONS_EDITOR;
}

export function resetRegionsEditor(): ResetRegionsEditor {
    return {
        type: RESET_REGIONS_EDITOR
    };
}

export const CLOSE_REGIONS_EDITOR = 'CLOSE_REGIONS_EDITOR';
export type CLOSE_REGIONS_EDITOR = typeof CLOSE_REGIONS_EDITOR;

export interface CloseRegionsEditor {
    type: CLOSE_REGIONS_EDITOR;
    id: string;
}

export function closeRegionsEditor(id: string): CloseRegionsEditor {
    return {
        type: CLOSE_REGIONS_EDITOR,
        id
    };
}

export type RegionsEditorAction =
    | OpenRegionsEditor
    | SelectRegionsEditorItem
    | DeselectRegionsEditorItem
    | ExpandRegionsEditorItem
    | CollapseRegionsEditorItem
    | SelectQuickRegionsEditorItem
    | DeselectQuickRegionsEditorItem
    | StartChangeFilterTextRegionsEditor
    | ChangeFilterTextRegionsEditor
    | SaveChangesRegionsEditor
    | CancelChangesRegionsEditor
    | ClearSelectedRegionsEditorItems
    | ResetRegionsEditor
    | CloseRegionsEditor;
